import React from 'react';
import Map from './senatni-obvody.svg';
import styles from './styles';
import colors from '../../colors';
import { percentFormat } from '../../Utils/NumberFormatting';
import UpdateBlocker from '../UpdateBlocker';

const idEquals = (id) => (item) => item && item === id || item.id === id

export default class MapSenate extends React.Component {
	ref = React.createRef();
	paths = [];

	componentDidMount() {
		this.paths = Array.prototype.slice.call(this.ref.current.querySelectorAll('path'));
		if (this.props.districts.length) {
			this.setup();
		}

		if (this.props.leaders.length || Object.keys(this.props.leaders).length) {
			this.colorize();
		}

		this.ref.current.addEventListener('click', this.onClick);
	}

	componentWillUnmount() {
		this.ref.current.removeEventListener('click', this.onClick);
	}

	componentDidUpdate(prevProps) {
		if (this.props.districts !== prevProps.districts) {
			this.setup();
		}

		if (this.props.leaders !== prevProps.leaders) {
			this.colorize();
		}
		this.setSelected();
	}

	onClick = (event) => {
		if (event.target.nodeType !== Node.ELEMENT_NODE || event.target.tagName !== 'path') {
			return;
		}

		const className = event.target.getAttribute('class');
		const isActive = className && className.indexOf('active') !== -1;
		if (!isActive) {
			return;
		}

		const id = event.target.getAttribute('data-id');

		this.props.onClick(id);
	}

	setSelected() {
		const { selectedAreaId } = this.props;
		this.paths.forEach((path) => {
			if (path.getAttribute('data-id') === selectedAreaId) {
				path.classList.add('selected');
			} else {
				path.classList.remove('selected');
			}
		});
	}

	getLeaderDetails(districtId) {
		const leader = this.props.leaders[districtId];

		if (leader) {
			const label =
					this.props.roundIndex === 1 && leader.elected[0] === 'ZVOLEN'
						? 'Zvolen v prvním kole'
						: percentFormat(leader.percent[this.props.roundIndex]);

			return `${leader.area.name}\n${leader.name} ${leader.lastName} (${leader.party.shortcut})\n${label}`;
		}
		return '';
	}

	setup() {
		this.paths.forEach((path, index) => {
			const id = index + 1;
			const active = this.props.districts.findIndex(idEquals(id)) !== -1;
			path.setAttribute('data-id', id);
			path.setAttribute('class', active ? 'active' : '');
			active && this.setTooltip(path, id);
		});
	}

	setTooltip(path, id) {
		const pathDistrict = this.props.districts.find(idEquals(id)) || {};
		const leaderDetails = this.getLeaderDetails(id);
		if (leaderDetails){
			path.querySelector('title').textContent = `${leaderDetails}`;
		} else if (pathDistrict.name) {
			path.querySelector('title').textContent = `${pathDistrict.name}`;
		}
	}

	colorize() {
		this.paths.forEach((path, index) => {
			const id = index + 1;
			const leader = this.props.leaders[id];

			if (!leader) {
				path.style.fill = null;
				return;
			}

			path.style.fill = colors[leader.party.nid || leader.party.vid] || colors.default;
		});
	}

	render() {
		return (
			<div ref={this.ref}>
				<UpdateBlocker>
					<Map className={styles} {...this.props.mapProps} />
				</UpdateBlocker>
			</div>
		);
	}
}

MapSenate.defaultProps = {
	mapProps: {},
	onClick: (id) => {
		window.location.hash = `/obvod/${id}`
	}
}
